/* This example requires Tailwind CSS v2.0+ */
import { Disclosure } from "@headlessui/react";
import { Trans, useTranslation } from "react-i18next";

const navigation = [
  {
    name: <Trans i18nKey="Home">Home</Trans>,
    href: "#",
    current: true,
  },
  {
    name: <Trans i18nKey="Guide Line">Guide Line</Trans>,
    href: "#",
    current: false,
  },
  {
    name: <Trans i18nKey="Contact us">Contact us</Trans>,
    href: "#",
    current: false,
  },
  { name: <Trans i18nKey="Terms">Terms</Trans>, href: "#", current: false },
];

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function Footer() {
  const { t } = useTranslation();
  return (
    <Disclosure
      as="nav"
      className="absolute bottom-0 w-full bg-[#1E408E] py-[20px]"
    >
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-2 sm:px-10 lg:px-20">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">
                    <Trans i18nKey="Open main menu">Open main menu</Trans>
                  </span>
                  {!open ? (
                    <span>
                      <Trans i18nKey="Menu">Menu</Trans>
                    </span>
                  ) : (
                    <span>
                      <Trans i18nKey="close">close</Trans>
                    </span>
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                <div className="hidden sm:ml-6 sm:block">
                  <div className="flex space-x-4">
                    {navigation.map((item, v) => (
                      <a
                        key={v}
                        href={item.href}
                        className={classNames(
                          // item.current
                          // ? "bg-gray-900 text-white"
                          // : "text-gray-300 hover:bg-gray-700 hover:text-white",
                          "text-gray-300 hover:bg-gray-700 hover:text-white",
                          "px-3 py-2 rounded-md text-sm font-medium"
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex flex-shrink-0 items-center">
                <img
                  className="h-8 w-auto"
                  src="/images/logo-dark.png"
                  alt="Your Company"
                />
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pt-2 pb-3">
              {navigation.map((item, v) => (
                <Disclosure.Button
                  key={v}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-900 text-white"
                      : "text-gray-300 hover:bg-gray-700 hover:text-white",
                    "block px-3 py-2 rounded-md text-base font-medium"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
